import React from "react";
import queryString from "query-string";
import { Search } from "history";
import { responseValidator } from "../../services/responseValidator";
import { authService } from "../../services/authService";
import { InternalError } from "../../models/internal-error.model";
import { NpuError } from "../../models/error.model";
import { JwtToken } from "../../models/token.model";
import { Role } from "../../models/static.model";
import { config } from "../../utils/config";
import Logger from "../../utils/logger";
import { LOGIN_PATH } from "../Routes/var_PATHS";
import CircularSpinner from "../spinners/circular";
import { Grid } from "@material-ui/core";

type AuthProps = {
  location: Search;
};

const AuthComponent: React.FC<AuthProps> = (props: AuthProps) => {
  const logger = new Logger("AuthComponent");

  const ERROR_CODE_PARAM = "errorCode";

  const queryParams = queryString.parse(props.location);

  ((_) => {
    if (
      !queryParams.accessToken ||
      !queryParams.refreshToken ||
      !queryParams.role
    ) {
      const url = `${LOGIN_PATH}?${ERROR_CODE_PARAM}=${InternalError.NotFoundAuthParamsError}`;
      window.location.replace(url);
    } else {
      const refreshToken: JwtToken = queryParams.refreshToken as JwtToken;
      const sessionToken: JwtToken = queryParams.accessToken as JwtToken;
      const role: Role = responseValidator.parseRole(
        queryParams.role as string
      );

      if (role === Role.Unknown) {
        const url = `${LOGIN_PATH}?${ERROR_CODE_PARAM}=${InternalError.NotFoundAuthParamsError}`;
        return window.location.replace(url);
      }

      logger.debug("role :", role);
      logger.debug("sessionToken :", sessionToken);
      logger.debug("refreshToken :", refreshToken);

      authService
        .login(role, sessionToken, refreshToken)
        .then(() => {
          setTimeout(() => {
            role === Role.Admin
              ? window.location.replace("/bulletins")
              : role === Role.Assistant
                ? window.location.replace("/bulletins")
                : role === Role.User
                  ? window.location.replace("/bulletins")
                  :
                  window.location.replace("/account");
          }, 2000);
        })
        .catch((error) => {
          if (error instanceof NpuError) {
            const { errorCode } = error as NpuError;
            const url = `${config.feBaseUrl}${LOGIN_PATH}?${ERROR_CODE_PARAM}=${errorCode}`;
            window.location.replace(url);
          } else {
            const url = `${config.feBaseUrl}${LOGIN_PATH}?${ERROR_CODE_PARAM}=${InternalError.GeneralError}&msg=${error.errorMessage}`;
            logger.error(error);
            window.location.replace(url);
            throw error;
          }
        });
    }
  })();

  return (
    <>
      <Grid container item xs justify="center" style={{ marginTop: 320 }}>
        <CircularSpinner />
      </Grid>
    </>
  );
};

export default AuthComponent;
